import apiClient from "./apiClient";

export const validateLogin = async (pharmacyid, username, password, networkId) => {
    try {
        const response = await apiClient.post('/login/ValidateLogin', {
            UserID: username,
            Password: password,
            PharmacyID: pharmacyid,
            NetworkID: networkId
        });
        console.log('Response from validateLogin:', response);

        if (response.data?.RetValue === 1) {
            return {
                success: true,
                data: {
                    userId: response.data.UserID?.trim(),
                    fullName: response.data.FullName?.trim(),
                    pharmacyId: response.data.PharmacyID,
                    isAdmin: response.data.Admin === "1",
                    contract: response.data.Contract,
                    createdDate: response.data.CreatedDate,
                    editedDate: response.data.EditedDate,
                    passwordExpireDate: response.data.PWExpireDate,
                    authorizeType: response.data.AuthorizeType,
                    cancelOrderEnabled: response.data.CancelOrder === "Enable",
                    userRestrictedAccess: response.data.UserRestrictAcess === "Yes",
                    pharmName: response.data.PharmName
                }
            };
        } else if (response.data?.RetValue === 2) {
    return {
        success: false,
        changePassword: true,
        message: "Password change required."
    };
} else {
            return {
                success: false,
                message: "Invalid credentials!"
            };
        }
    } catch (error) {
        console.error('Error during login:', error);
        return {
            success: false,
            message: 'Incorrect Pharmacy ID or Username or Password.',
        };
    }
};

export const getToken = async (pharmacyId, userId, password, networkId) => {
    try {
        const payload = {
            PharmacyID: pharmacyId,
            UserID: userId,
            Password: password,
            NetworkID: networkId
        };

        console.log('Request payload for getToken:', payload);
        const response = await apiClient.post('/login/GetTokenId', payload);
        console.log('Response from getToken:', response.data);

        if (response.status === 200) {
            return {
                success: true,
                data: response.data?.Token?.TokenId ?? null,
                message: response.data?.BaseResult?.StatusDescription ?? null
            };
        } else {
            return {
                success: false,
                message: "Failed to retrieve token."
            };
        }
    } catch (error) {
        console.error('Error fetching token:', error);
        return {
            success: false,
            message: 'Incorrect Pharmacy ID or Username or Password.',
        };
    }
};

export const logout = async () => {
    try {
        const response = await apiClient.post('/login/Logout');
        console.log('Response from logout:', response.data);
        return {
            success: true,
            message: 'Logout successful.'
        };
    } catch (error) {
        console.error('Error during logout:', error);
        return {
            success: false,
            message: 'Logout failed.'
        };
    }
}
